import { isDemo } from "config/env";
import { SignupChargeDetails } from "features/types";

export const planIdProperty = isDemo ? "demoId" : "prodId";

export const SEASON_TICKET_CHECKOUT_STEP = 20;

export const getSinglePrice = (charge: SignupChargeDetails) => {
  const { signupCharge } = charge;
  const signupFees = charge.signupFees ?? [];
  const totalFees = signupFees.reduce((sum, f) => sum + Number(f.feeAmount), 0);
  return Number(signupCharge) + totalFees;
};
